import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { hidden: true },
  },
  {
    path: '/',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', component: () => import('@/views/dashboard/index.vue'), meta: { title: '仪表盘' } },
      { path: 'users', component: () => import('@/views/users/index.vue'), meta: { title: '用户管理' } },
      { path: 'posts', component: () => import('@/views/posts/index.vue'), meta: { title: '帖子管理' } },
      { path: 'banners', component: () => import('@/views/banners/index.vue'), meta: { title: '轮播图管理' } },
      { path: 'announcements', component: () => import('@/views/announcements/index.vue'), meta: { title: '公告管理' } },
      { path: 'comments', component: () => import('@/views/comments/index.vue'), meta: { title: '评论管理' } },
      { path: 'messages', component: () => import('@/views/messages/index.vue'), meta: { title: '私信管理' } },
      { path: 'favorites', component: () => import('@/views/favorites/index.vue'), meta: { title: '收藏管理' } },
      { path: 'reports', component: () => import('@/views/reports/index.vue'), meta: { title: '举报处理' } },
      { path: 'merchant-verifications', component: () => import('@/views/merchant-verifications/index.vue'), meta: { title: '商家认证审核' } },
      { path: 'keywords', component: () => import('@/views/keywords/index.vue'), meta: { title: '关键词管理' } },
      { path: 'members/orders', component: () => import('@/views/members/orders.vue'), meta: { title: '推广订单流水' } },
      { path: 'finance', component: () => import('@/views/finance/index.vue'), meta: { title: '财务管理' } },
      { path: 'config/cities', component: () => import('@/views/config/Cities.vue'), meta: { title: '城市管理' } },
      { path: 'config/pricing', component: () => import('@/views/config/Pricing.vue'), meta: { title: '价格配置' } },
      { path: 'config/payment-feature', component: () => import('@/views/config/PaymentFeature.vue'), meta: { title: '交易功能开关' } },
      { path: 'config/publish-entry', component: () => import('@/views/config/PublishEntry.vue'), meta: { title: '发布入口开关' } },
      { path: 'config/publish-modules', component: () => import('@/views/config/PublishModules.vue'), meta: { title: '发布模块开关' } },
      { path: 'config/chat-feature', component: () => import('@/views/config/ChatFeature.vue'), meta: { title: '私信功能开关' } },
      { path: 'config/country-whitelist', component: () => import('@/views/config/CountryWhitelist.vue'), meta: { title: '国家白名单' } },
      { path: 'config/pin-limits', component: () => import('@/views/config/PinLimits.vue'), meta: { title: '帖子置顶管理' } },
      { path: 'config/publish-options', component: () => import('@/views/config/PublishOptions.vue'), meta: { title: '发布类型管理' } },
      { path: 'config/promotion-packages', component: () => import('@/views/config/PromotionPackages.vue'), meta: { title: '麦屯推广包' } },
      { path: 'security', component: () => import('@/views/security/index.vue'), meta: { title: '安全设置' } },
      {
        path: 'permissions',
        component: () => import('@/views/permissions/index.vue'),
        meta: { title: '权限管理', requiresSuperAdmin: true },
      },
      {
        path: 'logs',
        component: () => import('@/views/logs/index.vue'),
        meta: { title: '操作日志', requiresSuperAdmin: true },
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token');
  const role = localStorage.getItem('admin_role');
  if (to.path === '/login') {
    next();
  } else if (!token) {
    next('/login');
  } else if (to.meta && to.meta.requiresSuperAdmin && role !== 'SUPER_ADMIN') {
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
